import Header from './Header'
import { useMainContext } from '../callContext/MainContext'
import { TiTick } from "react-icons/ti";

const Language = () => {
    const {language,handleLanguageChange}=useMainContext();
    const languages = [
      { code: 'en', label: 'English' ,id:1},
      { code: 'fr', label: 'French' ,id:2},
    ];
  return (
    <div className='min-h-screen'>
    <Header />
    <div className='pt-28 m-auto px-4 cursor-pointer'>
          {languages.map((lang) => (
          <div
            key={lang?.code}
            className={`border-2 p-2 flex rounded-md mb-2 cursor-pointer ${
              language === lang.code ? 'yellow-theme-color text-white font-bold' : ''
            }`}
            onClick={() => handleLanguageChange(lang.code)}
          >
          {language === lang.code ?
            <div className='rounded-full border-2 border-white mr-3 h-6 w-6'><TiTick size={20}/></div>:
           <p className='p-2 rounded-full border-2 border-[#FFCB00] mr-3 h-6 w-6'></p>}
           {lang.label}
          </div>
        ))}
    </div>
    </div>
  )
}

export default Language